import axios from "axios";

// All Mannskapsplanlegger calls go through this module.
// Set VUE_APP_API_URL to run against a local API.
export const API_URL = process.env.VUE_APP_API_URL || "https://api.eines-as.no";

const data = (res) => res.data;

export default {
  getPlan({ from, to, vessel } = {}) {
    return axios.get(`${API_URL}/crewplan`, { params: { from, to, vessel } }).then(data);
  },

  getAvailability({ from, to, order } = {}) {
    return axios.get(`${API_URL}/crewplan/availability`, { params: { from, to, order } }).then(data);
  },

  recalculate(vessel) {
    return axios.post(`${API_URL}/crewplan/recalculate`, { vessel }).then(data);
  },

  saveRule(rule) {
    return rule.id
      ? axios.put(`${API_URL}/rotasjon/${rule.id}`, rule).then(data)
      : axios.post(`${API_URL}/rotasjon`, rule).then(data);
  },

  deleteRule(id) {
    return axios.delete(`${API_URL}/rotasjon/${id}`).then(data);
  },

  saveChange(change) {
    return change.id
      ? axios.put(`${API_URL}/mannskapsendringer/${change.id}`, change).then(data)
      : axios.post(`${API_URL}/mannskapsendringer`, change).then(data);
  },

  deleteChange(id) {
    return axios.delete(`${API_URL}/mannskapsendringer/${id}`).then(data);
  },

  // Partial order update (skift, skift_manual, crew_locked). The API recalculates crew afterwards.
  updateOrder(id, fields) {
    return axios.put(`${API_URL}/orders/${id}`, fields).then(data);
  },

  updateSkift(id, fields) {
    return axios.put(`${API_URL}/skift/${id}`, fields).then(data);
  },
};

// Shared labels and helpers for the planner components.
export const REASONS = [
  { value: "syk", text: "Syk" },
  { value: "ferie", text: "Ferie" },
  { value: "kurs", text: "Kurs" },
  { value: "permisjon", text: "Permisjon" },
  { value: "annet", text: "Annet" },
];

export const reasonLabel = (value) => (REASONS.find((r) => r.value === value) || {}).text || value;

export const MODES = [
  { value: "periode", text: "Fast periode", help: "Skiftene bytter etter et fast antall dager, f.eks. 14 på / 14 av." },
  { value: "ordre", text: "Per ordre", help: "Skiftene bytter for hver ny ordre på fartøyet." },
  { value: "manuell", text: "Manuell", help: "Skift velges for hver ordre i planleggeren." },
];

export const modeLabel = (value) => (MODES.find((m) => m.value === value) || {}).text || "Ingen regel";

const PALETTE = ["#4e73df", "#1cc88a", "#f6c23e", "#e74a3b", "#36b9cc", "#6f42c1", "#fd7e14", "#20c997"];

export const skiftColor = (skift, index = 0) => (skift && skift.color) || PALETTE[index % PALETTE.length];

export const errorText = (error) =>
  (error && error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
  "Noe gikk galt. Prøv igjen.";
